export default __webpack_public_path__ + "static/media/Wholesale3.9533b5fc.jpg";